<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialog"
    width="720px"
    style="text-align:left;"
    :close-on-click-modal="false"
    append-to-body
    class="big"
    :show-close="false"
  >
    <div class="content">
      <div>
        <el-input
          v-model="keywords"
          placeholder="请输入商品"
          style="width:200px"
        ></el-input>
        <el-button
          type="primary"
          @click="getList"
          style="margin-left:20px"
        >查询</el-button>
      </div>
      <div class="table_list">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          height="500"
          style="width: 100%; "
          :header-cell-style="{ background: '#F5F5F5' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            label="商品"
            width="340"
          >
            <template slot-scope="scope">
              <div
                class="flex"
                style="width: 300px"
              >
                <el-image
                  :src="scope.row.picture"
                  :preview-src-list="[scope.row.picture]"
                  style="width: 80px; height: 80px"
                />
                <div style="width: 180px;margin-left:15px">
                  <div>{{ scope.row.goods_name }}</div>
                  <div style="color:#666;font-size:12px">{{ scope.row.sku_name_arr }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_price"
            label="商品价格"
            width="140px"
          />
          <el-table-column
            prop="stock"
            label="库存"
          />
        </el-table>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="close"
        plain
      >取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      keywords: '',
      dialog: true,
      page: 1,
      total: 0,
      list: [],
      selection: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        keywords: this.keywords,
        pageNumber: 1000,
        page: 1
      };
      this.axios.post('platform/Shop/getShopGoodsList', data).then((res) => {
        this.list = res.data.list.map((item) => {
          if (item.sku_name) {
            let arr = item.sku_name.split(',');
            let arr_name = arr.map((item) => {
              return '【' + item + '】';
            });
            item.sku_name_arr = arr_name.toString();
          }
          return item;
        });
      });
    },
    close() {
      this.$emit('close');
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    submit() {
      this.$emit('checkGoods', this.selection);
      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.table_list {
  border: solid 1px #c9cbd6;
  margin-top: 20px;
}
</style>
